import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DashNavbar from './DashNavbar';
import TermsAcceptance from '../TermsAcceptance';

const DashLayout = () => {
  const [showTerms, setShowTerms] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if we're on the dashboard page
    if (location.pathname === '/dashboard') {
      const termsAccepted = localStorage.getItem('termsAccepted');
      const termsAcceptedAt = localStorage.getItem('termsAcceptedAt');
      
      // Vérifier si les conditions ont été acceptées et si elles n'ont pas expiré
      // (2 heures = 2 * 60 * 60 * 1000 millisecondes)
      const twoHoursInMs = 2 * 60 * 60 * 1000;
      const isExpired = termsAcceptedAt && (Date.now() - Number(termsAcceptedAt) > twoHoursInMs);
      
      // Afficher le disclaimer si jamais accepté OU si l'acceptation a expiré
      if (!termsAccepted || isExpired) {
        setShowTerms(true);
        
        // Si expiré, nettoyer le localStorage pour forcer une nouvelle acceptation
        if (isExpired) {
          localStorage.removeItem('termsAccepted');
          localStorage.removeItem('termsAcceptedAt');
        }
      }
    }
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <DashNavbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      {showTerms && <TermsAcceptance onClose={() => setShowTerms(false)} />}
    </div>
  );
};

export default DashLayout;
